import { render, staticRenderFns } from "./rno_portal.vue?vue&type=template&id=2f086833&"
import script from "./rno_portal.vue?vue&type=script&lang=js&"
export * from "./rno_portal.vue?vue&type=script&lang=js&"
import style0 from "./rno_portal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports